import { render, staticRenderFns } from "./addServiceProvider.vue?vue&type=template&id=8040bd7c&scoped=true"
import script from "./addServiceProvider.vue?vue&type=script&lang=js"
export * from "./addServiceProvider.vue?vue&type=script&lang=js"
import style0 from "./addServiceProvider.vue?vue&type=style&index=0&id=8040bd7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8040bd7c",
  null
  
)

export default component.exports